import { Tabs, Tab, Paper } from "@mui/material";

const CustomTabs = ({ value, onChange, tabsList = [] , tabVariant='standard' , alignCenter=false }) => {
  return (
    <Paper
      style={{
        margin: "0px 1px 5px 1px",
        boxShadow: "0px 0px 2px 0.5px #BBBBBB",
      }}
    >
      <Tabs
        value={value}
        onChange={onChange}
        variant={tabVariant}
        scrollButtons="auto"
        centered={alignCenter}
        sx={{
          minHeight: 42,
          '& .MuiTab-root': {
            minHeight: 42,
            height: 42,
            padding: alignCenter ? '0' : '6px 16px'
          }
        }}
      >
        {tabsList.map((tabLabel, index) => (
          <Tab key={index} label={tabLabel} sx={{ fontSize: '13px' }} />
        ))}
      </Tabs>
    </Paper>
  );
};

export default CustomTabs;